module.exports = __webpack_public_path__ + "assets/img/2r.97a47306.png";